import React, { useEffect, useState, useCallback } from 'react';
import { Slider } from "@mui/material";
import './index.css'
function CustomSlider(props) {
  const [value, setValue] = useState([props.intialStartvalue, props.intialEndvalue]); // initial value

  const handleChange = useCallback((event, newValue) => {
    if (props.name === "lowSlider" && props?.changeLowSliderEndValue) {
      if (newValue?.[0] < newValue?.[1] && newValue?.[1] > newValue?.[0] && newValue?.[0] >= props.initialValue?.[0] && newValue?.[0] < props.initialValue?.[1] && newValue?.[1] <= props.initialValue?.[1]) {
        setValue(newValue);
        props?.getSliderData(props.name, newValue);
        props.changeLowSliderEndValue(props.name, newValue)
      }
    }
    if (props.name === "mediumSlider" && props?.changeMediumSliderEndValue) {
      if (newValue?.[0] < newValue?.[1] && newValue?.[1] > newValue?.[0] && newValue?.[0] === props.initialValue?.[0] && newValue?.[0] < props.initialValue?.[1] && newValue?.[1] <= props.initialValue?.[1]) {
        setValue(newValue);
        props?.getSliderData(props.name, newValue);
        props.changeMediumSliderEndValue(props.name, newValue)
      }
    }
  });
  useEffect(() => {
    setValue([props.intialStartvalue, props.intialEndvalue]);
  }, [props?.formData?.lowSlider, props?.formData?.mediumSlider, props?.formData?.highSlider, props?.thresholdValue])

  return (
    <div >
      <Slider
        className={"custom-slider" || props.className}
        value={value}
        onChange={handleChange}
        marks={[
          { value: 0, label: `${value[0]}${props.thresholdValue === "percentage" ? " %" : " days"}` },
          ...Array.from({ length: value[1] - value[0] - 1 }, (i) => ({
            value: value[0] + i + 1,
            label: '',
            style: { borderRadius: 6, border: '1px solid #ccc', backgroundColor: '#fff' },
          })),
          { value: props.name === "highSlider" ? 999 : (props.name !== "highSlider" && props.thresholdValue === "percentage") ? 100 : 225, label: `${value[1]}${props.thresholdValue === "percentage" ? " %" : " days"}` },
        ]}
        valueLabelDisplay="on"
        valueLabelFormat={(value) => `${value}${props.thresholdValue === "percentage" ? " %" : " days"}`}
        min={0}
        max={props.name === "highSlider" ? 999 : (props.name !== "highSlider" && props.thresholdValue === "percentage") ? 100 : 250}
        disabled={props.disabled || false}
        sx={{
          "& .MuiSlider-track": { backgroundColor: props.name !== "highSlider" ? "#000" : "#c8c8c8" },
        }}
      />
    </div>
  );
}

export default CustomSlider;

